import React from "react";
import siteMetadata from "../siteMetadata";
import ArticleSummary from "./ArticleSummary";
import Bio from "./Bio";
import Pagination from "./Pagination";
import styles from "./BlogIndexPage.module.css";

function BlogIndexPage({ blogRoot, pageCount, pageNumber, postRoutes }) {
  const isFirstPage = pageNumber === 1;

  return (
    <div>
      {isFirstPage && (
        <section className={styles.hero}>
          <div className={styles.heroBadge}>Insights &amp; Guides</div>
          <h1 className={styles.heroTitle}>{siteMetadata.title}</h1>
          <p className={styles.heroSubtitle}>{siteMetadata.description}</p>
          <Bio />
        </section>
      )}

      {!isFirstPage && (
        <header className={styles.pageHeader}>
          <h1 className={styles.pageTitle}>
            {siteMetadata.title}
            <span className={styles.pageNumber}> — page {pageNumber}</span>
          </h1>
        </header>
      )}

      <ul className={styles.articlesList}>
        {postRoutes.map((route) => (
          <li key={route.url.href}>
            <ArticleSummary blogRoot={blogRoot} route={route} />
          </li>
        ))}
      </ul>

      {pageCount > 1 && (
        <Pagination
          blogRoot={blogRoot}
          pageCount={pageCount}
          pageNumber={pageNumber}
        />
      )}
    </div>
  );
}

export default BlogIndexPage;
